export enum CalculationContactTypeEnum {
  Callback = 'callback',
  Mailback = 'mailback',
}
